define([], function() {	
	
	var Social = {
			
		shareWindow : function(vendor) {
			var canonical = encodeURIComponent($('link[rel=canonical]').attr('href')),
				desc = encodeURIComponent($('head title').text()),
				media = encodeURIComponent($('meta[property=og\\:image]').attr('content'))
			if (vendor=='facebook') {
				if(!COSTCO.whiteList.isOnWhiteList('"facebook.com"')){
					COSTCO.dialog.createExtDialogBox({
						title :  messages.JS_DIALOG_EXTERNAL_LINK,
						body : isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
						secondary: messages.JS_DIALOG_CANCEL,
						primary : messages.JS_DIALOG_EXTERNAL_LINK,
						primary_event: function() {
							window.open('https://www.facebook.com/sharer/sharer.php?u='+canonical+'&t='+desc,'','left=0,top=0,width=626,height=436,toolbar=1,location=0,resizable=1,scrollbars=1');
							COSTCO.dialog.close();
						},
					});
				} else {
					window.open('https://www.facebook.com/sharer/sharer.php?u='+canonical+'&t='+desc,'','left=0,top=0,width=626,height=436,toolbar=1,location=0,resizable=1,scrollbars=1');
				};
			} else if (vendor=='twitter') {
				if(!COSTCO.whiteList.isOnWhiteList('"twitter.com"')){
					COSTCO.dialog.createExtDialogBox({
						title :  messages.JS_DIALOG_EXTERNAL_LINK,
						body : isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
						secondary: messages.JS_DIALOG_CANCEL,
						primary : messages.JS_DIALOG_EXTERNAL_LINK,
						primary_event: function() {
							window.open('https://twitter.com/intent/tweet?url='+canonical,'','left=0,top=0,width=795,height=700,toolbar=1,location=0,resizable=1,scrollbars=1');
							COSTCO.dialog.close();
						},
					});
				} else {
					window.open('https://twitter.com/intent/tweet?text='+desc+'&url='+canonical,'','left=0,top=0,width=795,height=700,toolbar=1,location=0,resizable=1,scrollbars=1');
				};
			} else if (vendor=='pinterest') {
				if(!COSTCO.whiteList.isOnWhiteList('"pinterest.com"')){
					COSTCO.dialog.createExtDialogBox({
						title :  messages.JS_DIALOG_EXTERNAL_LINK,
						body : isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
						secondary: messages.JS_DIALOG_CANCEL,
						primary : messages.JS_DIALOG_EXTERNAL_LINK,
						primary_event: function() {
							window.open('https://www.pinterest.com/pin/create/button/?url='+canonical+'&media='+media+'&description='+desc,'','left=0,top=0,width=700,height=600,toolbar=1,location=0,resizable=1,scrollbars=1');
							COSTCO.dialog.close();
						},
					});
				} else {
					window.open('https://www.pinterest.com/pin/create/button/?url='+canonical+'&media='+media+'&description='+desc,'','left=0,top=0,width=700,height=600,toolbar=1,location=0,resizable=1,scrollbars=1');
				};
			} else if (vendor=='google') {
				if(!COSTCO.whiteList.isOnWhiteList('"google.com"')){
					COSTCO.dialog.createExtDialogBox({
						title :  messages.JS_DIALOG_EXTERNAL_LINK,
						body : isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
						secondary: messages.JS_DIALOG_CANCEL,
						primary : messages.JS_DIALOG_EXTERNAL_LINK,
						primary_event: function() {
							window.open('https://plus.google.com/share?url='+canonical, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
							COSTCO.dialog.close();
						},
					});
				} else {
					window.open('https://plus.google.com/share?url='+canonical, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
				};
			}
		}
			
	} //End Vendor object
	
	if(typeof window.COSTCO == 'undefined'){
		window.COSTCO = new Object();
	}
	
	window.COSTCO.Social = Social;
	
    return Social;
	
});


// WEBPACK FOOTER //
// ./js/product/social.js